const brazilLocation = [
  -10.000000,
  -55.000000,
];

const isLatitude = (lat: number): boolean => {
  return Number.isFinite(lat) && Math.abs(lat) <= 90;
};

const isLongitude = (lng: number): boolean => {
  return Number.isFinite(lng) && Math.abs(lng) <= 180;
};

export {
  isLatitude,
  isLongitude,
  brazilLocation,
};
